declare var __com_umbragroup_resources: any;

export const resources: { [name: string]: string } = __com_umbragroup_resources;
